import React from 'react';
import { Form, Formik } from 'formik';

import {
  FormikExtendedContextProvider,
} from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/FormikWrapper';

const renderChildrenRecursively = (child, childProps, displayRequiredIndicator) => {
  const { fieldName, type, htmlType, children } = child.props;

  if (type === 'submit' || htmlType === 'submit') {
    // Honour the call site's own disabled as well as Formik's state, so a
    // guard set by the form (CheckoutV2's, for one) is not lost.
    const disabled = Boolean(child.props.disabled) || childProps.isSubmitting;
    return React.cloneElement(child, { disabled }, children);
  }

  const fieldProps = {
    touched: childProps.touched[fieldName],
    error: childProps.errors[fieldName],
    value: childProps.values[fieldName],
    displayRequiredIndicator: displayRequiredIndicator,
  };

  return React.cloneElement(child, { ...child.props, ...fieldProps }, React.Children.map(children, (subchild) => {
    // Happens when we conditionally render elements.
    if (!subchild) {
      return null;
    }

    // Happens for simple text nodes.
    if (!subchild.props) {
      return <span>{subchild}</span>;
    }

    // eslint-disable-next-line no-shadow
    const { fieldName, children } = subchild.props;
    // eslint-disable-next-line no-shadow
    const fieldProps = {
      touched: childProps.touched[fieldName],
      error: childProps.errors[fieldName],
      value: childProps.values[fieldName],
      displayRequiredIndicator: displayRequiredIndicator,
    };

    if (children) {
      return renderChildrenRecursively(subchild, { ...childProps }, displayRequiredIndicator);
    }

    return React.cloneElement(subchild, { ...childProps, ...fieldProps }, null);
  }));
};

const FormikWrapper = (props) => {
  const {
    initialValues,
    onSubmit,
    displayRequiredIndicator,
    validate,
    validateOnChange,
    validateOnBlur,
    validateOnMount,
    onReset,
    ...restProps
  } = props;

  return (
    <Formik
      initialValues={initialValues || {}}
      onSubmit={onSubmit}
      validate={validate}
      validateOnChange={validateOnChange}
      validateOnBlur={validateOnBlur}
      validateOnMount={validateOnMount}
      onReset={onReset}
      {...restProps}
    >
      {
        (childProps) => {
          return (
            <FormikExtendedContextProvider>
              {/* Clone the children so that we can add childProps to each child. */}
              {React.Children.map(
                // eslint-disable-next-line react/destructuring-assignment
                props.children(childProps),
                (child) => {
                  return renderChildrenRecursively(child, childProps, displayRequiredIndicator);
                },
              )}
            </FormikExtendedContextProvider>
          );
        }
      }
    </Formik>
  );
};

export default FormikWrapper;
